module.exports = __webpack_public_path__ + "static/media/like.9451dff5.svg";